import './style.scss'

import React, { Component } from 'react'
import { autoCompleteSearch, changeSearchValue } from 'actions/Search'

import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import SearchResultDropdown from 'components/Search/SearchResultDropdown'
import TextInput from 'components/UI/TextInput'
import classNames from 'classnames'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import onClickOutside from 'react-onclickoutside'
import { push } from 'connected-react-router'
import searchIcon from 'theme/icons/search.svg'
import { toggleSearchDropdown } from 'actions/UI'
import { withTranslation } from 'react-i18next'

export class SearchInput extends Component {
    constructor() {
        super()
        this.performSearch = debounce(this.performSearch, 50)

        this.handleValueChange = this.handleValueChange.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }

    performSearch(query) {
        this.props.dispatch(autoCompleteSearch(query))
    }

    handleValueChange(query) {
        this.props.dispatch(changeSearchValue(query))
        this.performSearch(query)
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.props.dispatch(push(`/search/${this.props.searchValue}`))
            this.props.dispatch(toggleSearchDropdown(false))
        }
    }

    handleClickOutside() {
        if (this.props.showSearchResultDropdown) {
            this.props.dispatch(toggleSearchDropdown(false))
        }
        this._input && this._input.blur()
    }

    handleFocus(e) {
        if (e && e.target && e.target.value) {
            this.props.dispatch(toggleSearchDropdown(true))
        }
    }

    render() {
        const { searchValue, showSearchResultDropdown, showMobile, type, t } = this.props
        const classes = classNames({
            'ignore-react-onclickoutside': true,
            'search-input': true,
            'search-input--show-mobile': showMobile,
            [`search-input--${type}`]: type,
        })

        return (
            <div className={classes} onKeyDown={this.handleKeyDown}>
                <TextInput
                    id="productSearch"
                    inputRef={(r) => (this._input = r)}
                    icon={<Icon svg={searchIcon} />}
                    placeholder={t('searchProducts')}
                    value={searchValue}
                    onChange={this.handleValueChange}
                    onFocus={this.handleFocus}
                />
                {showSearchResultDropdown && <SearchResultDropdown />}
            </div>
        )
    }
}

SearchInput.propTypes = {
    showSearchResultDropdown: PropTypes.bool,
    searchValue: PropTypes.string,
    showMobile: PropTypes.bool,
    dispatch: PropTypes.func,
    type: PropTypes.oneOf(['faded']),
    t: PropTypes.func,
}

const mapStateToProps = ({ ui, search }) => {
    return {
        showSearchResultDropdown: ui.showSearchResultDropdown,
        searchValue: search.searchValue,
    }
}

export default connect(mapStateToProps)(withTranslation()(onClickOutside(SearchInput)))
